import {Observable} from 'rxjs';
import {WidgetActionEvent} from '../../../pages/dashboard/layout/widget';
import {WidgetHeaderTitlePart} from '../../../pages/dashboard/layout/widget/widget-header/widget-header-title';
import {WidgetSettings} from './widget-settings';
import {WidgetSettingsService} from './widget-settings-service';

export enum WidgetImplementationEventType {
    INIT,
    SETTINGS_UPDATED,

    /**
     * Allows to pass {@link WidgetActionEvent} from implementation to {@link Widget}.
     */
    WIDGET_ACTION
}

export interface WidgetImplementationEvent {
    type: WidgetImplementationEventType | unknown;
    payload?: any;
    flags?: WidgetImplementationEventFlags;
}

export interface WidgetImplementationEventFlags {
    [flag: string]: any;
}

export interface WidgetInitializedEvent extends WidgetImplementationEvent {
    type: WidgetImplementationEventType.INIT;
}

export interface WidgetSettingsUpdatedEvent extends WidgetImplementationEvent {
    type: WidgetImplementationEventType.SETTINGS_UPDATED;
    payload: Partial<WidgetSettings>;
}

export interface WidgetImplToWidgetActionEvent<T extends WidgetActionEvent = WidgetActionEvent>
    extends WidgetImplementationEvent {

    type: WidgetImplementationEventType.WIDGET_ACTION;
    payload: T;
}

export interface WidgetImplementation<T_SETTINGS = WidgetSettings> {
    settings: T_SETTINGS;
    settingsService: WidgetSettingsService;
    ready$: Observable<boolean>;
    event$: Observable<WidgetImplementationEvent>;
    initialDependency$?: Observable<unknown>;
    settingsWithUpdates$?: Observable<Partial<T_SETTINGS>>;
    title$?: Observable<string>;
    titleParts$?: Observable<WidgetHeaderTitlePart[]>;

    /**
     * [HED-282] Prevent saving of not initialized settings:
     * if the widget is in the process of applying its initial settings,
     * then we should store not yet processed settings in the layout
     * instead of empty/default settings.
     */
    isInitialized?: boolean;
    pendingSettings?: T_SETTINGS;

    setSettings(
        settings?: T_SETTINGS,
        flags?: WidgetImplementationEventFlags
    ): Observable<T_SETTINGS>;

    updateSettings(
        updates?: Partial<T_SETTINGS>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<T_SETTINGS>>;

    destroy?(): void;
}
